import { tm } from '../tm'
import i18n from './i18n'
import type { Locales, Project } from '@captaincause/types'

interface UrgentProjectBadgeProps {
  project: Project
  className?: string
  locale?: Locales
}

export function UrgentProjectBadge({
  project,
  className = '',
  locale = 'fr',
}: UrgentProjectBadgeProps) {
  if (!project.is_emergency) return null

  const t = i18n[locale] ?? i18n.fr

  return (
    <div
      className={tm(
        'flex h-8 items-center rounded-full bg-light-red px-3 py-2 text-center shadow-sm',
        className,
      )}
    >
      <span className="text-xs font-medium leading-[18px] text-dark-red">
        🚨 {t.title}
      </span>
    </div>
  )
}
